import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { debounce } from 'throttle-debounce';
import { findRegionByName } from '../../../../actions/geo';
import { getLocationsIfEmpty } from '../../../../actions/geo/getLocationsIfEmpty';
import { ILocation } from '../../../../types/location';

export const MIN_SEARCH_LENGTH = 3;

export interface IUseLocationSuggest {
  togglePopup(value: boolean): void;
}
export const useLocationSuggest = ({ togglePopup }: IUseLocationSuggest) => {
  const actions = bindActionCreators(
    {
      getLocationsIfEmpty,
      findRegionByName,
    },
    useDispatch(),
  );

  const [suggest, setSuggest] = useState<ILocation[]>([]);
  const [isFetching, setIsFetching] = useState(false);

  const getLocationSuggest = useCallback(
    async (value: string) => {
      if (value.length < MIN_SEARCH_LENGTH) {
        return;
      }

      setIsFetching(true);

      const locations = await actions.findRegionByName(value);

      togglePopup(true);
      setSuggest(locations);
      setIsFetching(false);
    },
    [actions, togglePopup],
  );

  const getLocationSuggestDebounced = useCallback(debounce(200, getLocationSuggest), [getLocationSuggest]);

  return {
    suggest,
    getLocationSuggest: getLocationSuggestDebounced,
    isFetching,
  };
};
